import { RecurrenceDaysOfWeekEnum } from '../../api/generated';

// Booking `type` discriminator on the polymorphic Booking payload. The generated client types it as
// a plain string, so it is not inferred — we set it explicitly when building a request. The other
// subtypes' discriminators live with their own features (e.g. STAFF, ROOM).
export const RESERVED_STAFF_TIME_TYPE = 'RESERVED_STAFF_TIME' as const;

// A new reservation defaults to one hour of flexible time.
export const DEFAULT_DURATION_MINUTES = 60;

// "Place it anywhere in the work week" — the eligible-days default when a reservation becomes
// recurring. The scheduler still intersects these with each staff member's actual working days.
export const WORK_WEEK_DAYS: readonly RecurrenceDaysOfWeekEnum[] = [
  RecurrenceDaysOfWeekEnum.Monday,
  RecurrenceDaysOfWeekEnum.Tuesday,
  RecurrenceDaysOfWeekEnum.Wednesday,
  RecurrenceDaysOfWeekEnum.Thursday,
  RecurrenceDaysOfWeekEnum.Friday
];
